function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { merge } from 'lodash';
import { getAggregatedWizardData } from "./data";
import { useStateMachine } from "../../utils/useStateMachine";
import { NetworkError } from '@applyboard/ui-utils';
import { eligibilitySteps } from "../../data/eligibility";
var states = {
  beforeOpen: ['closed_dialog'],
  eligibilityStep: [].concat(_toConsumableArray(eligibilitySteps), ['selecting_student', 'missing_student']),
  intakeStep: ['selecting_intake', 'selected_intake', 'missing_intake'],
  prerequisitesStep: ['loading_requirements', 'load_requirements_unknown_error', 'load_requirements_network_error', 'showing_prerequisites'],
  whatToExpectStep: ['showing_what_to_expect', 'creating_application']
};
export var isInStep = function isInStep(step, state) {
  return states[step].includes(state.value);
};
export function useApplicationWizardStateMachine() {
  var _useStateMachine = useStateMachine({
      initial: {
        value: 'closed_dialog',
        context: {
          expectedRequirements: [],
          requirementsEverExpanded: [],
          requirementsCurrentlyExpanded: [],
          intakes: [],
          featureFlags: {},
          showEligibilityStep: false,
          programWarnings: [],
          showProgramWarnings: false
        }
      },
      states: {
        closed_dialog: {
          OPENED_DIALOG: function OPENED_DIALOG(params) {
            var _event$currentProgram, _event$currentProgram2, _event$currentProgram3, _event$currentProgram4, _event$currentProgram5, _event$currentProgram6, _event$preSelectedInt, _event$currentSchool, _event$currentSchool2, _event$student;
            var event = params.event,
              dispatch = params.dispatch,
              transition = params.transition,
              trackEvent = params.trackEvent;
            var eventData = {
              event: 'New Application Wizard - Started',
              data: {
                programId: event.program.id,
                programLevel: event.program.programLevel,
                programName: event.program.name,
                currentProgramId: (_event$currentProgram = event.currentProgram) === null || _event$currentProgram === void 0 ? void 0 : _event$currentProgram.id,
                currentProgramLevel: (_event$currentProgram2 = event.currentProgram) === null || _event$currentProgram2 === void 0 ? void 0 : _event$currentProgram2.programLevel,
                currentScore: (_event$currentProgram3 = event.currentProgram) === null || _event$currentProgram3 === void 0 ? void 0 : _event$currentProgram3.successScore,
                currentScoreLevel: (_event$currentProgram4 = event.currentProgram) === null || _event$currentProgram4 === void 0 ? void 0 : _event$currentProgram4.successScoreLevel,
                currentAcademicIntake: (_event$currentProgram5 = event.currentProgram) === null || _event$currentProgram5 === void 0 ? void 0 : _event$currentProgram5.academicIntake,
                currentEslIntake: (_event$currentProgram6 = event.currentProgram) === null || _event$currentProgram6 === void 0 ? void 0 : _event$currentProgram6.eslIntake,
                preSelectedIntake: (_event$preSelectedInt = event.preSelectedIntake) === null || _event$preSelectedInt === void 0 ? void 0 : _event$preSelectedInt.startDate,
                scores: getSuccessScores({
                  selectedIntake: event.preSelectedIntake
                }),
                schoolId: event.school.id,
                schoolCountry: event.school.country,
                currentSchoolId: (_event$currentSchool = event.currentSchool) === null || _event$currentSchool === void 0 ? void 0 : _event$currentSchool.id,
                currentSchoolCountry: (_event$currentSchool2 = event.currentSchool) === null || _event$currentSchool2 === void 0 ? void 0 : _event$currentSchool2.country,
                studentId: (_event$student = event.student) === null || _event$student === void 0 ? void 0 : _event$student.id,
                sourcePage: event.pageName
              }
            };
            if (event.student && event.unknownStudentEligibility) {
              checkEligibility(params);
              trackEvent(merge(eventData, {
                data: {
                  steps: ['Eligibility', 'Prerequisites', 'What to Expect']
                }
              }));
              return;
            }
            if (event.student) {
              trackEvent(merge(eventData, {
                data: {
                  steps: ['Prerequisites', 'What to Expect']
                }
              }));
              transition('loading_requirements', {
                selectedStudent: event.student,
                selectedProgram: event.program,
                selectedSchool: event.school,
                preSelectedIntake: event.preSelectedIntake,
                currentProgram: event.currentProgram,
                currentSchool: event.currentSchool
              });
              getAggregatedWizardData({
                programId: event.program.id,
                studentId: event.student.id,
                signal: params.signal
              }).then(function (_ref) {
                var expectedRequirements = _ref.expectedRequirements,
                  eligibilityDetails = _ref.eligibilityDetails,
                  intakes = _ref.intakes,
                  featureFlags = _ref.featureFlags,
                  programWarnings = _ref.programWarnings;
                dispatch({
                  type: 'LOAD_REQUIREMENTS_SUCCEEDED',
                  expectedRequirements: expectedRequirements,
                  eligibilityDetails: eligibilityDetails,
                  intakes: intakes,
                  featureFlags: featureFlags,
                  showEligibilityStep: false,
                  programWarnings: programWarnings
                });
              })["catch"](function (err) {
                if (params.signal.aborted) return;
                dispatch({
                  type: 'LOAD_REQUIREMENTS_FAILED',
                  reason: err instanceof NetworkError ? 'load_requirements_network_error' : 'load_requirements_unknown_error'
                });
              });
              return;
            }
            transition('selecting_student', {
              selectedProgram: event.program,
              selectedSchool: event.school,
              preSelectedIntake: event.preSelectedIntake,
              currentProgram: event.currentProgram,
              currentSchool: event.currentSchool
            });
            trackEvent(merge(eventData, {
              data: {
                steps: ['Eligibility', 'Prerequisites', 'What to Expect']
              }
            }));
          }
        },
        loading_requirements: {
          LOAD_REQUIREMENTS_FAILED: function LOAD_REQUIREMENTS_FAILED(_ref2) {
            var event = _ref2.event,
              transition = _ref2.transition;
            return transition(event.reason);
          },
          LOAD_REQUIREMENTS_SUCCEEDED: function LOAD_REQUIREMENTS_SUCCEEDED(_ref3) {
            var event = _ref3.event,
              transition = _ref3.transition,
              context = _ref3.context;
            var contextToUpdate = {
              expectedRequirements: event.expectedRequirements,
              eligibilityDetails: event.eligibilityDetails,
              intakes: event.intakes,
              featureFlags: event.featureFlags,
              selectedIntake: calculateSelectedIntakeInContext(context, {
                intakes: event.intakes,
                featureFlags: event === null || event === void 0 ? void 0 : event.featureFlags,
                eligibilityDetails: event.eligibilityDetails
              }),
              showEligibilityStep: event.showEligibilityStep,
              programWarnings: event.programWarnings
            };
            if (shouldShowIntakeStep(event.intakes, event.featureFlags, event.eligibilityDetails)) {
              var _context$selectedInta;
              (_context$selectedInta = context.selectedIntake) !== null && _context$selectedInta !== void 0 && _context$selectedInta.intakeId ? transition('selected_intake', _objectSpread(_objectSpread({}, contextToUpdate), {}, {
                showProgramWarnings: true
              })) : transition('selecting_intake', _objectSpread(_objectSpread({}, contextToUpdate), {}, {
                selectedIntake: null,
                showProgramWarnings: true
              }));
            } else {
              transition('showing_prerequisites', _objectSpread({}, contextToUpdate));
            }
          },
          CLOSED_DIALOG: function CLOSED_DIALOG(_ref4) {
            var reset = _ref4.reset;
            return reset();
          }
        },
        load_requirements_unknown_error: {
          CLOSED_DIALOG: function CLOSED_DIALOG(_ref5) {
            var reset = _ref5.reset;
            return reset();
          }
        },
        load_requirements_network_error: {
          CLOSED_DIALOG: function CLOSED_DIALOG(_ref6) {
            var reset = _ref6.reset;
            return reset();
          }
        },
        selecting_student: {
          SELECTED_STUDENT: checkEligibility,
          NEXT_BUTTON_CLICKED: 'missing_student',
          CLOSED_DIALOG: function CLOSED_DIALOG(_ref7) {
            var reset = _ref7.reset;
            return reset();
          }
        },
        checking_eligibility: {
          ELIGIBILITY_CHECK_FAILED: function ELIGIBILITY_CHECK_FAILED(_ref8) {
            var event = _ref8.event,
              transition = _ref8.transition;
            return transition(event.reason);
          },
          ELIGIBILITY_CHECK_SUCCEEDED: function ELIGIBILITY_CHECK_SUCCEEDED(_ref9) {
            var event = _ref9.event,
              transition = _ref9.transition,
              trackEvent = _ref9.trackEvent,
              context = _ref9.context;
            var selectedIntake = calculateSelectedIntakeInContext(context, {
              intakes: event.intakes,
              featureFlags: event.featureFlags,
              eligibilityDetails: event.eligibilityDetails
            });
            transition(event.eligibilityDetails.eligibility, {
              eligibilityDetails: event.eligibilityDetails,
              expectedRequirements: event.expectedRequirements,
              eligibilityPermissions: event.eligibilityPermissions,
              pageName: context.pageName,
              intakes: event.intakes,
              featureFlags: event.featureFlags,
              selectedIntake: selectedIntake,
              showEligibilityStep: true,
              programWarnings: event.programWarnings
            });
            trackEvent({
              event: 'New Application Wizard - Eligibility Step - Selects Student',
              data: _objectSpread(_objectSpread({}, getCommonEventData(context)), {}, {
                eligibilityResult: event.eligibilityDetails.eligibility,
                intakeAvailable: event.eligibilityDetails.intakeAvailable,
                recruitmentRestricted: event.eligibilityDetails.recruitmentRestricted
              })
            });
          },
          CLOSED_DIALOG: function CLOSED_DIALOG(_ref10) {
            var reset = _ref10.reset;
            return reset();
          }
        },
        eligible: {
          SELECTED_STUDENT: checkEligibility,
          NEXT_BUTTON_CLICKED: function NEXT_BUTTON_CLICKED(_ref11) {
            var transition = _ref11.transition,
              context = _ref11.context,
              trackEvent = _ref11.trackEvent;
            trackEvent({
              event: 'New Application Wizard - Eligibility Step - Clicked Next',
              data: getCommonEventData(context)
            });
            if (shouldShowIntakeStep(context.intakes, context.featureFlags, context.eligibilityDetails)) {
              var _context$selectedInta2;
              (_context$selectedInta2 = context.selectedIntake) !== null && _context$selectedInta2 !== void 0 && _context$selectedInta2.intakeId ? transition('selected_intake', {
                showProgramWarnings: true
              }) : transition('selecting_intake', {
                showProgramWarnings: true
              });
            } else {
              transition('showing_prerequisites');
            }
          },
          CLOSED_DIALOG: handleClosedDialogEligibilityStep
        },
        ineligible: {
          SELECTED_STUDENT: checkEligibility,
          CLOSED_DIALOG: handleClosedDialogEligibilityStep,
          NEXT_BUTTON_CLICKED: handleNextButtonClickedNegativeState
        },
        ineligible_with_issues: {
          SELECTED_STUDENT: checkEligibility,
          CLOSED_DIALOG: handleClosedDialogEligibilityStep,
          NEXT_BUTTON_CLICKED: handleNextButtonClickedNegativeState
        },
        eligible_with_issues: {
          SELECTED_STUDENT: checkEligibility,
          CLOSED_DIALOG: handleClosedDialogEligibilityStep,
          NEXT_BUTTON_CLICKED: handleNextButtonClickedNegativeState
        },
        application_already_exists: {
          SELECTED_STUDENT: checkEligibility,
          CLOSED_DIALOG: handleClosedDialogEligibilityStep
        },
        eligibility_network_error: {
          SELECTED_STUDENT: checkEligibility,
          CLOSED_DIALOG: handleClosedDialogEligibilityStep
        },
        eligibility_unknown_error: {
          SELECTED_STUDENT: checkEligibility,
          CLOSED_DIALOG: handleClosedDialogEligibilityStep
        },
        missing_student: {
          SELECTED_STUDENT: checkEligibility,
          CLOSED_DIALOG: handleClosedDialogEligibilityStep
        },
        profile_incomplete: {
          SELECTED_STUDENT: checkEligibility,
          CLOSED_DIALOG: handleClosedDialogEligibilityStep,
          NEXT_BUTTON_CLICKED: function NEXT_BUTTON_CLICKED(_ref12) {
            var _context$eligibilityP;
            var transition = _ref12.transition,
              context = _ref12.context;
            if ((_context$eligibilityP = context.eligibilityPermissions) !== null && _context$eligibilityP !== void 0 && _context$eligibilityP.canApplyIgnoringEligibility) {
              transition('showing_prerequisites');
            }
          }
        },
        selecting_intake: {
          SELECTED_INTAKE: function SELECTED_INTAKE(_ref13) {
            var event = _ref13.event,
              transition = _ref13.transition,
              trackEvent = _ref13.trackEvent,
              context = _ref13.context;
            trackEvent({
              event: 'New Application Wizard - Intake Step - Intake Selected',
              data: _objectSpread(_objectSpread({}, getCommonEventData(context)), {}, {
                intakeStartDate: event.intake.startDate,
                intakeStatus: event.intake.intakeStatus,
                warningsReturned: getSelectedIntakeWarnings(context.intakes)
              })
            });
            transition('selected_intake', {
              selectedIntake: event.intake
            });
          },
          DESELECTED_INTAKE: function DESELECTED_INTAKE(_ref14) {
            var transition = _ref14.transition;
            transition('missing_intake', {
              selectedIntake: null
            });
          },
          NEXT_BUTTON_CLICKED: 'missing_intake',
          PREV_BUTTON_CLICKED: function PREV_BUTTON_CLICKED(_ref15) {
            var _context$eligibilityD;
            var context = _ref15.context,
              transition = _ref15.transition,
              trackEvent = _ref15.trackEvent;
            trackEvent({
              event: 'New Application Wizard - Intake Step - Clicked Previous',
              data: getCommonEventData(context)
            });
            if ((_context$eligibilityD = context.eligibilityDetails) !== null && _context$eligibilityD !== void 0 && _context$eligibilityD.eligibility) {
              transition(context.eligibilityDetails.eligibility);
            }
          },
          CLOSED_DIALOG: function CLOSED_DIALOG(_ref16) {
            var reset = _ref16.reset,
              trackEvent = _ref16.trackEvent;
            trackEvent({
              event: 'New Application Wizard - Intake Step - Clicked Cancel'
            });
            reset();
          }
        },
        missing_intake: {
          SELECTED_INTAKE: function SELECTED_INTAKE(_ref17) {
            var _event$intake;
            var event = _ref17.event,
              transition = _ref17.transition,
              trackEvent = _ref17.trackEvent,
              context = _ref17.context;
            trackEvent({
              event: 'New Application Wizard - Intake Step - Intake Selected',
              data: _objectSpread(_objectSpread({}, getCommonEventData(context)), {}, {
                selectedIntake: (_event$intake = event.intake) === null || _event$intake === void 0 ? void 0 : _event$intake.startDate
              })
            });
            transition('selected_intake', {
              selectedIntake: event.intake
            });
          },
          DESELECTED_INTAKE: function DESELECTED_INTAKE(_ref18) {
            var transition = _ref18.transition;
            transition('missing_intake', {
              selectedIntake: null
            });
          },
          PREV_BUTTON_CLICKED: function PREV_BUTTON_CLICKED(_ref19) {
            var _context$eligibilityD2;
            var context = _ref19.context,
              transition = _ref19.transition;
            if ((_context$eligibilityD2 = context.eligibilityDetails) !== null && _context$eligibilityD2 !== void 0 && _context$eligibilityD2.eligibility) {
              transition(context.eligibilityDetails.eligibility);
            }
          },
          CLOSED_DIALOG: function CLOSED_DIALOG(_ref20) {
            var reset = _ref20.reset,
              trackEvent = _ref20.trackEvent;
            trackEvent({
              event: 'New Application Wizard - Intake Step - Clicked Cancel'
            });
            reset();
          }
        },
        selected_intake: {
          SELECTED_INTAKE: function SELECTED_INTAKE(_ref21) {
            var _event$intake2;
            var event = _ref21.event,
              transition = _ref21.transition,
              trackEvent = _ref21.trackEvent,
              context = _ref21.context;
            trackEvent({
              event: 'New Application Wizard - Intake Step - Intake Selected',
              data: _objectSpread(_objectSpread({}, getCommonEventData(context)), {}, {
                selectedIntake: (_event$intake2 = event.intake) === null || _event$intake2 === void 0 ? void 0 : _event$intake2.startDate
              })
            });
            transition('selected_intake', {
              selectedIntake: event.intake
            });
          },
          DESELECTED_INTAKE: function DESELECTED_INTAKE(_ref22) {
            var transition = _ref22.transition;
            transition('selecting_intake', {
              selectedIntake: null
            });
          },
          NEXT_BUTTON_CLICKED: function NEXT_BUTTON_CLICKED(_ref23) {
            var transition = _ref23.transition,
              context = _ref23.context,
              trackEvent = _ref23.trackEvent;
            trackEvent({
              event: 'New Application Wizard - Intake Step - Clicked Next',
              data: getCommonEventData(context)
            });
            transition('showing_prerequisites');
          },
          PREV_BUTTON_CLICKED: function PREV_BUTTON_CLICKED(_ref24) {
            var _context$eligibilityD3;
            var context = _ref24.context,
              transition = _ref24.transition,
              trackEvent = _ref24.trackEvent;
            trackEvent({
              event: 'New Application Wizard - Intake Step - Clicked Previous',
              data: getCommonEventData(context)
            });
            if ((_context$eligibilityD3 = context.eligibilityDetails) !== null && _context$eligibilityD3 !== void 0 && _context$eligibilityD3.eligibility) {
              transition(context.eligibilityDetails.eligibility);
            }
          },
          CLOSED_DIALOG: function CLOSED_DIALOG(_ref25) {
            var reset = _ref25.reset,
              trackEvent = _ref25.trackEvent;
            trackEvent({
              event: 'New Application Wizard - Intake Step - Clicked Cancel'
            });
            reset();
          },
          LEARN_MORE_CLICKED: function LEARN_MORE_CLICKED(_ref26) {
            var trackEvent = _ref26.trackEvent,
              context = _ref26.context;
            trackEvent({
              event: 'New Application Wizard - Intake Step - Clicked Learn More For Important Intake Details',
              data: {
                warningsReturned: getSelectedIntakeWarnings(context.intakes)
              }
            });
          },
          WARNING_INSIGHTS_MODAL_VIEW_CHANGED: function WARNING_INSIGHTS_MODAL_VIEW_CHANGED(_ref27) {
            var event = _ref27.event,
              trackEvent = _ref27.trackEvent;
            trackEvent({
              event: 'New Application Wizard - Intake Step - Toggled View In Important Intake Details Modal',
              data: {
                whatView: "".concat(event.targetView, " view")
              }
            });
          }
        },
        showing_prerequisites: {
          PREV_BUTTON_CLICKED: function PREV_BUTTON_CLICKED(_ref28) {
            var _context$eligibilityD4;
            var context = _ref28.context,
              transition = _ref28.transition,
              trackEvent = _ref28.trackEvent;
            trackEvent({
              event: 'New Application Wizard - Prerequisite Step - Clicked Previous',
              data: getCommonEventData(context)
            });
            if (shouldShowIntakeStep(context.intakes, context.featureFlags, context.eligibilityDetails)) {
              var _context$selectedInta3;
              (_context$selectedInta3 = context.selectedIntake) !== null && _context$selectedInta3 !== void 0 && _context$selectedInta3.intakeId ? transition('selected_intake') : transition('selecting_intake');
            } else if ((_context$eligibilityD4 = context.eligibilityDetails) !== null && _context$eligibilityD4 !== void 0 && _context$eligibilityD4.eligibility) {
              transition(context.eligibilityDetails.eligibility);
            }
          },
          NEXT_BUTTON_CLICKED: function NEXT_BUTTON_CLICKED(_ref29) {
            var _context$expectedRequ;
            var context = _ref29.context,
              transition = _ref29.transition,
              trackEvent = _ref29.trackEvent;
            var prerequisiteRequirements = (_context$expectedRequ = context.expectedRequirements) === null || _context$expectedRequ === void 0 ? void 0 : _context$expectedRequ.filter(isPrerequisiteStepRequirement);
            trackEvent({
              event: 'New Application Wizard - Prerequisite Step - Clicked Next',
              data: _objectSpread(_objectSpread({}, getCommonEventData(context)), {}, {
                numberOfRequirements: (prerequisiteRequirements === null || prerequisiteRequirements === void 0 ? void 0 : prerequisiteRequirements.length) || 0,
                requirementTemplateIds: prerequisiteRequirements.map(function (requirement) {
                  return requirement.id;
                }),
                requirementsEverExpanded: context.requirementsEverExpanded,
                requirementsCurrentlyExpanded: context.requirementsCurrentlyExpanded
              })
            });
            transition('showing_what_to_expect', {
              requirementsEverExpanded: [],
              requirementsCurrentlyExpanded: []
            });
          },
          EXPANDED_ACCORDION: function EXPANDED_ACCORDION(_ref30) {
            var context = _ref30.context,
              trackEvent = _ref30.trackEvent;
            trackEvent({
              event: 'New Application Wizard - Prerequisite Step - Clicked Expand All',
              data: getCommonEventData(context)
            });
          },
          COLLAPSED_ACCORDION: function COLLAPSED_ACCORDION(_ref31) {
            var context = _ref31.context,
              trackEvent = _ref31.trackEvent;
            trackEvent({
              event: 'New Application Wizard - Prerequisite Step - Clicked Collapse All',
              data: getCommonEventData(context)
            });
          },
          TOGGLED_SEE_MORE: function TOGGLED_SEE_MORE(_ref32) {
            var event = _ref32.event,
              transition = _ref32.transition;
            transition('showing_prerequisites', {
              requirementsEverExpanded: event.requirementsEverExpanded,
              requirementsCurrentlyExpanded: event.requirementsCurrentlyExpanded
            });
          },
          CLOSED_DIALOG: function CLOSED_DIALOG(_ref33) {
            var _context$expectedRequ2;
            var reset = _ref33.reset,
              context = _ref33.context,
              trackEvent = _ref33.trackEvent;
            var prerequisiteRequirements = (_context$expectedRequ2 = context.expectedRequirements) === null || _context$expectedRequ2 === void 0 ? void 0 : _context$expectedRequ2.filter(isPrerequisiteStepRequirement);
            trackEvent({
              event: 'New Application Wizard - Prerequisite Step - Clicked Cancel',
              data: _objectSpread(_objectSpread({}, getCommonEventData(context)), {}, {
                requirementTemplateIds: prerequisiteRequirements === null || prerequisiteRequirements === void 0 ? void 0 : prerequisiteRequirements.map(function (requirement) {
                  return requirement.id;
                }),
                requirementsEverExpanded: context.requirementsEverExpanded,
                requirementsCurrentlyExpanded: context.requirementsCurrentlyExpanded
              })
            });
            reset();
          }
        },
        showing_what_to_expect: {
          PREV_BUTTON_CLICKED: function PREV_BUTTON_CLICKED(_ref34) {
            var transition = _ref34.transition,
              trackEvent = _ref34.trackEvent,
              context = _ref34.context;
            trackEvent({
              event: 'New Application Wizard - What to Expect Step - Clicked Previous',
              data: getCommonEventData(context)
            });
            transition('showing_prerequisites', {
              requirementsEverExpanded: [],
              requirementsCurrentlyExpanded: []
            });
          },
          NEXT_BUTTON_CLICKED: function NEXT_BUTTON_CLICKED(_ref35) {
            var _context$expectedRequ3, _context$selectedProg;
            var transition = _ref35.transition,
              context = _ref35.context,
              trackEvent = _ref35.trackEvent;
            var whatToExpectRequirements = (_context$expectedRequ3 = context.expectedRequirements) === null || _context$expectedRequ3 === void 0 ? void 0 : _context$expectedRequ3.filter(function (requirement) {
              return !isPrerequisiteStepRequirement(requirement);
            });
            trackEvent({
              event: 'New Application Wizard - What to Expect Step - Clicked Create Application',
              data: _objectSpread(_objectSpread({}, getCommonEventData(context)), {}, {
                seatAvailabilityChance: (_context$selectedProg = context.selectedProgram) === null || _context$selectedProg === void 0 ? void 0 : _context$selectedProg.seatAvailabilityChance,
                numberOfRequirements: (whatToExpectRequirements === null || whatToExpectRequirements === void 0 ? void 0 : whatToExpectRequirements.length) || 0,
                requirementTemplateIds: whatToExpectRequirements === null || whatToExpectRequirements === void 0 ? void 0 : whatToExpectRequirements.map(function (requirement) {
                  return requirement.id;
                }),
                requirementsEverExpanded: context.requirementsEverExpanded,
                requirementsCurrentlyExpanded: context.requirementsCurrentlyExpanded
              })
            });
            transition('creating_application');
          },
          EXPANDED_ACCORDION: function EXPANDED_ACCORDION(_ref36) {
            var context = _ref36.context,
              trackEvent = _ref36.trackEvent;
            trackEvent({
              event: 'New Application Wizard - What to Expect Step - Clicked Expand All',
              data: getCommonEventData(context)
            });
          },
          COLLAPSED_ACCORDION: function COLLAPSED_ACCORDION(_ref37) {
            var context = _ref37.context,
              trackEvent = _ref37.trackEvent;
            trackEvent({
              event: 'New Application Wizard - What to Expect Step - Clicked Collapse All',
              data: getCommonEventData(context)
            });
          },
          TOGGLED_SEE_MORE: function TOGGLED_SEE_MORE(_ref38) {
            var event = _ref38.event,
              transition = _ref38.transition;
            transition('showing_what_to_expect', {
              requirementsEverExpanded: event.requirementsEverExpanded,
              requirementsCurrentlyExpanded: event.requirementsCurrentlyExpanded
            });
          },
          CLOSED_DIALOG: function CLOSED_DIALOG(_ref39) {
            var _context$expectedRequ4;
            var reset = _ref39.reset,
              trackEvent = _ref39.trackEvent,
              context = _ref39.context;
            var whatToExpectRequirements = (_context$expectedRequ4 = context.expectedRequirements) === null || _context$expectedRequ4 === void 0 ? void 0 : _context$expectedRequ4.filter(function (requirement) {
              return !isPrerequisiteStepRequirement(requirement);
            });
            trackEvent({
              event: 'New Application Wizard - What to Expect Step - Clicked Cancel',
              data: _objectSpread(_objectSpread({}, getCommonEventData(context)), {}, {
                requirementTemplateIds: whatToExpectRequirements === null || whatToExpectRequirements === void 0 ? void 0 : whatToExpectRequirements.map(function (requirement) {
                  return requirement.id;
                }),
                requirementsEverExpanded: context.requirementsEverExpanded,
                requirementsCurrentlyExpanded: context.requirementsCurrentlyExpanded
              })
            });
            reset();
          }
        }
      }
    }),
    _useStateMachine2 = _slicedToArray(_useStateMachine, 2),
    state = _useStateMachine2[0],
    dispatch = _useStateMachine2[1];
  return [state, dispatch];
}
function checkEligibility(_ref40) {
  var event = _ref40.event,
    transition = _ref40.transition,
    dispatch = _ref40.dispatch,
    context = _ref40.context,
    signal = _ref40.signal;
  if (!event.student) {
    dispatch({
      type: 'ELIGIBILITY_CHECK_FAILED',
      reason: 'eligibility_unknown_error'
    });
    return;
  }
  transition('checking_eligibility', {
    selectedStudent: event.student,
    selectedProgram: event.program,
    selectedSchool: event.school
  });
  var program = event.program || context.selectedProgram;
  if (!program) {
    dispatch({
      type: 'ELIGIBILITY_CHECK_FAILED',
      reason: 'eligibility_unknown_error'
    });
    return;
  }
  getAggregatedWizardData({
    programId: program.id,
    studentId: event.student.id,
    signal: signal
  }).then(function (_ref41) {
    var eligibilityDetails = _ref41.eligibilityDetails,
      expectedRequirements = _ref41.expectedRequirements,
      eligibilityPermissions = _ref41.eligibilityPermissions,
      intakes = _ref41.intakes,
      featureFlags = _ref41.featureFlags,
      programWarnings = _ref41.programWarnings;
    dispatch({
      type: 'ELIGIBILITY_CHECK_SUCCEEDED',
      eligibilityDetails: eligibilityDetails,
      expectedRequirements: expectedRequirements,
      eligibilityPermissions: eligibilityPermissions,
      intakes: intakes,
      featureFlags: featureFlags,
      programWarnings: programWarnings
    });
  })["catch"](function (err) {
    if (signal.aborted) return;
    dispatch({
      type: 'ELIGIBILITY_CHECK_FAILED',
      reason: err instanceof NetworkError ? 'eligibility_network_error' : 'eligibility_unknown_error'
    });
  });
}
export function shouldShowEligibilityStep(state) {
  if (isInStep('eligibilityStep', state)) {
    return true;
  }
  return !!state.context.showEligibilityStep;
}
function shouldShowIntakeStep(intakes, featureFlags, eligibilityDetails) {
  var _eligibilityDetails$c, _eligibilityDetails$c2, _eligibilityDetails$c3, _eligibilityDetails$c4;
  return intakes && intakes.length > 0 && (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.application_view_intake_step_in_app_wizard) && ((eligibilityDetails === null || eligibilityDetails === void 0 ? void 0 : (_eligibilityDetails$c = eligibilityDetails.criteria) === null || _eligibilityDetails$c === void 0 ? void 0 : (_eligibilityDetails$c2 = _eligibilityDetails$c.engTest) === null || _eligibilityDetails$c2 === void 0 ? void 0 : _eligibilityDetails$c2.eligibility) === 'eligible' || (eligibilityDetails === null || eligibilityDetails === void 0 ? void 0 : (_eligibilityDetails$c3 = eligibilityDetails.criteria) === null || _eligibilityDetails$c3 === void 0 ? void 0 : (_eligibilityDetails$c4 = _eligibilityDetails$c3.engTest) === null || _eligibilityDetails$c4 === void 0 ? void 0 : _eligibilityDetails$c4.eligibility) === undefined && (eligibilityDetails === null || eligibilityDetails === void 0 ? void 0 : eligibilityDetails.eligibility) === 'eligible');
}
export function shouldShowIntakeStepBasedOnState(state) {
  if (isInStep('intakeStep', state)) {
    return true;
  }
  return shouldShowIntakeStep(state.context.intakes, state.context.featureFlags, state.context.eligibilityDetails);
}
export function getWizardSteps(state) {
  if (shouldShowEligibilityStep(state) && shouldShowIntakeStepBasedOnState(state)) {
    return ['eligibilityStep', 'intakeStep', 'prerequisitesStep', 'whatToExpectStep'];
  }
  if (shouldShowEligibilityStep(state)) {
    return ['eligibilityStep', 'prerequisitesStep', 'whatToExpectStep'];
  }
  if (shouldShowIntakeStepBasedOnState(state)) {
    return ['intakeStep', 'prerequisitesStep', 'whatToExpectStep'];
  }
  return ['prerequisitesStep', 'whatToExpectStep'];
}
export function isPrerequisiteStepRequirement(expectedRequirement) {
  return expectedRequirement.requirementType === 'disclaimer' && expectedRequirement.applicationStage === 'pre-payment';
}
function getCommonEventData(context) {
  var _context$selectedProg2, _context$selectedProg3, _context$selectedScho, _context$selectedScho2, _context$selectedStud, _context$currentProgr, _context$currentProgr2, _context$currentProgr3, _context$currentProgr4, _context$currentSchoo, _context$currentSchoo2, _context$currentProgr5, _context$currentProgr6, _context$selectedInta4;
  var data = {
    programId: (_context$selectedProg2 = context.selectedProgram) === null || _context$selectedProg2 === void 0 ? void 0 : _context$selectedProg2.id,
    programLevel: (_context$selectedProg3 = context.selectedProgram) === null || _context$selectedProg3 === void 0 ? void 0 : _context$selectedProg3.programLevel,
    schoolId: (_context$selectedScho = context.selectedSchool) === null || _context$selectedScho === void 0 ? void 0 : _context$selectedScho.id,
    schoolCountry: (_context$selectedScho2 = context.selectedSchool) === null || _context$selectedScho2 === void 0 ? void 0 : _context$selectedScho2.country,
    studentId: (_context$selectedStud = context.selectedStudent) === null || _context$selectedStud === void 0 ? void 0 : _context$selectedStud.id,
    currentProgramId: (_context$currentProgr = context.currentProgram) === null || _context$currentProgr === void 0 ? void 0 : _context$currentProgr.id,
    currentProgramLevel: (_context$currentProgr2 = context.currentProgram) === null || _context$currentProgr2 === void 0 ? void 0 : _context$currentProgr2.programLevel,
    currentScore: (_context$currentProgr3 = context.currentProgram) === null || _context$currentProgr3 === void 0 ? void 0 : _context$currentProgr3.successScore,
    currentScoreLevel: (_context$currentProgr4 = context.currentProgram) === null || _context$currentProgr4 === void 0 ? void 0 : _context$currentProgr4.successScoreLevel,
    currentSchoolId: (_context$currentSchoo = context.currentSchool) === null || _context$currentSchoo === void 0 ? void 0 : _context$currentSchoo.id,
    currentSchoolCountry: (_context$currentSchoo2 = context.currentSchool) === null || _context$currentSchoo2 === void 0 ? void 0 : _context$currentSchoo2.country,
    currentAcademicIntake: (_context$currentProgr5 = context.currentProgram) === null || _context$currentProgr5 === void 0 ? void 0 : _context$currentProgr5.academicIntake,
    currentEslIntake: (_context$currentProgr6 = context.currentProgram) === null || _context$currentProgr6 === void 0 ? void 0 : _context$currentProgr6.eslIntake,
    selectedIntake: (_context$selectedInta4 = context.selectedIntake) === null || _context$selectedInta4 === void 0 ? void 0 : _context$selectedInta4.startDate
  };
  return data;
}
function handleClosedDialogEligibilityStep(_ref42) {
  var reset = _ref42.reset,
    trackEvent = _ref42.trackEvent,
    context = _ref42.context;
  trackEvent({
    event: 'New Application Wizard - Eligibility Step - Clicked Cancel',
    data: getCommonEventData(context)
  });
  reset();
}
function handleNextButtonClickedNegativeState(_ref43) {
  var _context$eligibilityP2;
  var transition = _ref43.transition,
    context = _ref43.context,
    trackEvent = _ref43.trackEvent;
  if ((_context$eligibilityP2 = context.eligibilityPermissions) !== null && _context$eligibilityP2 !== void 0 && _context$eligibilityP2.canApplyIgnoringEligibility) {
    trackEvent({
      event: 'New Application Wizard - Eligibility Step - Clicked Next',
      data: getCommonEventData(context)
    });
    if (shouldShowIntakeStep(context.intakes, context.featureFlags, context.eligibilityDetails)) {
      var _context$selectedInta5;
      (_context$selectedInta5 = context.selectedIntake) !== null && _context$selectedInta5 !== void 0 && _context$selectedInta5.intakeId ? transition('selected_intake', {
        showProgramWarnings: true
      }) : transition('selecting_intake', {
        showProgramWarnings: true
      });
    } else {
      transition('showing_prerequisites');
    }
  }
}
function getSuccessScores(_ref44) {
  var selectedIntake = _ref44.selectedIntake;
  if (selectedIntake) {
    return [{
      intake: selectedIntake.startDate
    }];
  }
}
var calculateSelectedIntakeInContext = function calculateSelectedIntakeInContext(context, event) {
  var _context$preSelectedI2;
  // If the intake selection step is enabled, the intake passed to the component should be
  // in the list of intakes; in this case we pre-select it. If the intake is not in the list
  // of intakes, we set the selectedIntake to null so that the user can select one of the options.

  if (!shouldShowIntakeStep(event.intakes, event.featureFlags, event.eligibilityDetails)) {
    var _context$preSelectedI;
    return (_context$preSelectedI = context.preSelectedIntake) !== null && _context$preSelectedI !== void 0 && _context$preSelectedI.intakeId ? context.preSelectedIntake : null;
  }
  var isPreSelectedIntakeExistAndValid = Boolean(event.intakes && ((_context$preSelectedI2 = context.preSelectedIntake) === null || _context$preSelectedI2 === void 0 ? void 0 : _context$preSelectedI2.intakeId) && event.intakes.some(function (intake) {
    var _context$preSelectedI3;
    return intake.intakeId === ((_context$preSelectedI3 = context.preSelectedIntake) === null || _context$preSelectedI3 === void 0 ? void 0 : _context$preSelectedI3.intakeId);
  }));
  if (isPreSelectedIntakeExistAndValid) {
    var _event$intakes;
    return (_event$intakes = event.intakes) === null || _event$intakes === void 0 ? void 0 : _event$intakes.find(function (intake) {
      var _context$preSelectedI4;
      return intake.intakeId === ((_context$preSelectedI4 = context.preSelectedIntake) === null || _context$preSelectedI4 === void 0 ? void 0 : _context$preSelectedI4.intakeId);
    });
  }
  return null;
};
function getSelectedIntakeWarnings(intakes) {
  return intakes === null || intakes === void 0 ? void 0 : intakes.filter(function (intake) {
    return intake.warningInsights.length > 0;
  }).map(function (intake) {
    return intake.warningInsights.map(function (warning) {
      var warningData = {
        intake: intake.startDate,
        title: warning.title,
        'description (applicant view)': warning.description
      };
      if (warning.detailedDescription) {
        warningData['detailedDescription (admin view)'] = warning.detailedDescription;
      }
      return warningData;
    });
  });
}